const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;

// Conversion-Labels aus Google Ads (Ziele > Conversions > Tag einrichten > "Ereignis-Snippet", Teil nach dem "/"). Werte in frontend/.env.
const LABELS = {
  firmenregistrierung: process.env.REACT_APP_GADS_LABEL_REGISTRIERUNG,
  platzbestellung: process.env.REACT_APP_GADS_LABEL_BESTELLUNG,
};

const SENT_KEY = "lw_ads_conv_sent";
const alreadySent = (id) => { try { return JSON.parse(sessionStorage.getItem(SENT_KEY) || "[]").includes(id); } catch { return false; } };
const markSent = (id) => { try { const l = JSON.parse(sessionStorage.getItem(SENT_KEY) || "[]"); sessionStorage.setItem(SENT_KEY, JSON.stringify([...l, id].slice(-50))); } catch {} };

export function trackConversion(key, { value, transactionId } = {}) {
  if (typeof window.gtag !== "function") return;
  const dedupeId = `${key}:${transactionId || Date.now()}`;
  if (transactionId && alreadySent(dedupeId)) return;
  const label = LABELS[key];
  // Neutrales GA4-Ereignis (kein "purchase": Verkauf auf Rechnung, keine Zahlungsbestätigung)
  window.gtag("event", key === "platzbestellung" ? "schulungsplaetze_bestellt" : "firma_registriert", {
    currency: "EUR", ...(value !== undefined && { value }), ...(transactionId && { transaction_id: transactionId }),
  });
  if (!ADS_ID || !label) {
    console.warn(`[Google Ads] Conversion "${key}" nicht gesendet – Conversion-Label fehlt in frontend/.env`);
  } else {
    const params = { send_to: `${ADS_ID}/${label}`, currency: "EUR" };
    if (value !== undefined) params.value = value;
    if (transactionId) params.transaction_id = transactionId;
    window.gtag("event", "conversion", params);
  }
  if (transactionId) markSent(dedupeId);
}
